import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/chef/informations')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/chef/informations"!</div>
}
